#import "./inboxRequisitionFields.graphql"

# The caller's approval queue, with the requisition for the list and the detail.
# Same audience as approve and refuse. No poll: load once, refetch after a write.
query workforceGuardrailInbox {
  workforceGuardrailQueue {
    waitingCount
    requisitions {
      id
      approverGroupId
      approverGroupName
      elapsedHours
      clockStartedAt
      pastSla
      requisition {
        ...InboxRequisitionFields
      }
    }
  }
}
